export enum ApprovalFlowTypeEnum {
  Regular = 'Regular',
  Emergency = 'Emergency',
}
